import React from 'react'
import { IResults } from '../../../../types'
import { toFloat, inputDevider } from '../../../../helper.ts'
import { PLUS } from '../../../../constants.jsx';

const PreResult: React.FC<IResults> = ({name, result, currency, validator = 0}) => {

  const mutation = result <= validator ? validator : result;
  
  const floatResult = inputDevider(toFloat(mutation.toString()))
  
  return (
    <div className="calculator__pre-result" data-currency={currency}>
      <div className="calculator__pre-result__inner">
        <div className="calculator__pre-result__name">
          <img src={PLUS} alt="plus" />
          <span>{ name }</span>
        </div>
        <div className="calculator__pre-result__text">
          {currency}{ floatResult }
        </div>
      </div>
    </div>
  );
}

export default PreResult
